import styled from "styled-components";

import { ReactComponent as Svg } from "./ribbon.svg";

const Container = styled.div`
  position: absolute;
  width: 146px;
  height: 146px;
`;

const RibbonSvg = styled(Svg)`
  width: 146px;
  height: 146px;
`;

const LabelContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 112px;
  height: 112px;
  bottom: 0;
  right: 0;
`;

const Label = styled.span`
  display: inline-block;
  text-align: center;
  font-family: ${({ theme }): string => theme.fonts.main};
  font-size: ${({ theme }): string => theme.fontSizes.size22};
  line-height: 1;
  color: white;
  transform: rotate(-45deg);
  filter: drop-shadow(2px 2px 0px rgba(200, 0, 0, 1));
`;

interface IProps {
  label: string;
}

export const Ribbon = ({ label }: IProps): JSX.Element => (
  <Container>
    <RibbonSvg />
    <LabelContainer>
      <Label>{label}</Label>
    </LabelContainer>
  </Container>
);
